import React from 'react';
import Layout from '../layouts/MainLayout/MainLayout';

function NotFound() {
  return (
    <Layout>
      <div className="min-h-screen flex justify-center">
        <h1>Not Found</h1>
      </div>
    </Layout>
  );
}

export default NotFound;
